import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=fecc6bba&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=fecc6bba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fecc6bba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fecc6bba')) {
      api.createRecord('fecc6bba', component.options)
    } else {
      api.reload('fecc6bba', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=fecc6bba&scoped=true&", function () {
      api.rerender('fecc6bba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2fnh8Ndvy0N7K/JS/comp/DocBox.vue"
export default component.exports